'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024101 from "./presto.-Presto-Router$$anon$101.js";
import * as $j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024 from "./presto.-Signed-Documents-History-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$100() {
  this.bcY = null;
  this.bcQ = null;
  this.bcR = false;
  this.bcZ = null;
  this.bd0 = false;
  this.bd3 = null;
  this.bcW = null;
  this.bcX = false;
  this.bcS = null;
  this.bcT = false;
  this.bcU = null;
  this.bcV = false;
  this.bd1 = false;
  this.bd2 = false;
  this.bcY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bd3 = "SignedDocumentsHistoryPage";
}
export { $c_Lpresto_PrestoRouter$$anon$100 as $c_Lpresto_PrestoRouter$$anon$100 };
$p = $c_Lpresto_PrestoRouter$$anon$100.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$100;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$100() {
}
export { $h_Lpresto_PrestoRouter$$anon$100 as $h_Lpresto_PrestoRouter$$anon$100 };
$h_Lpresto_PrestoRouter$$anon$100.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bcY;
});
$p.L = (function() {
  if ((!this.bcR)) {
    this.bcQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcR = true;
  }
  return this.bcQ;
});
$p.O = (function() {
  if ((!this.bd0)) {
    this.bcZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bd0 = true;
  }
  return this.bcZ;
});
$p.E = (function() {
  return this.bd3;
});
$p.t = (function() {
  if ((!this.bcX)) {
    this.bcW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bcX = true;
  }
  return this.bcW;
});
$p.M = (function() {
  if ((!this.bcT)) {
    this.bcS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bcT = true;
  }
  return this.bcS;
});
$p.Q = (function() {
  if ((!this.bcV)) {
    this.bcU = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024101.$c_Lpresto_PrestoRouter$$anon$101();
    this.bcV = true;
  }
  return this.bcU;
});
$p.w = (function() {
  if ((!this.bd2)) {
    this.bd1 = false;
    this.bd2 = true;
  }
  return this.bd1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee611) => ((p) => \u03b4scrutinee611))($j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024.$m_Lpresto_SignedDocumentsHistoryPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$100 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$100, "presto.PrestoRouter$$anon$100", ({
  Nn: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$100 as $d_Lpresto_PrestoRouter$$anon$100 };
//# sourceMappingURL=presto.-Presto-Router$$anon$100.js.map
